import Vue from 'vue'
import AntDesignVue from 'ant-design-vue'

import 'ant-design-vue/dist/antd.less'

Vue.use(AntDesignVue)
